import { useMedicoSearch } from 'hooks/useMedico';
import { useEffect, useRef } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';

function MedicoAsyncSelect({ nomeMed, onSelect, onClear, disabled, styles, search }) {
  // 1. Consome diretamente a instância única repassada pelo pai
  const {
    query,
    setQuery,
    options,
    setOptions,
    isSearching,
    showDropdown,
    setShowDropdown,
    buscar,
  } = search;
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setShowDropdown(false);
    };
    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, [setShowDropdown]);

  const displayValue = nomeMed || query;
  const isSelected = Boolean(nomeMed);

  return (
    <div ref={wrapperRef} style={{ position: 'relative', flex: 1, display: 'flex' }}>
      <div style={{ position: 'relative', flex: 1 }}>
        <Form.Control
          size="sm"
          value={displayValue}
          onChange={(e) => {
            if (nomeMed) onClear?.();
            buscar(e.target.value);
          }}
          onFocus={() => !isSelected && options.length > 0 && setShowDropdown(true)}
          disabled={disabled}
          placeholder="Digite o nome (mín. 3 letras)"
          autoComplete="off"
          style={{
            ...styles.compact,
            borderRadius: displayValue ? '4px 0 0 4px' : '4px',
            backgroundColor: isSelected ? '#f0fdf4' : undefined,
            borderColor: isSelected ? '#86efac' : undefined,
            textTransform: 'uppercase',
          }}
        />
        {isSearching && (
          <Spinner
            animation="border"
            size="sm"
            style={{
              position: 'absolute',
              right: 8,
              top: '50%',
              transform: 'translateY(-50%)',
              width: 13,
              height: 13,
              borderWidth: 2,
              color: '#9ca3af',
              pointerEvents: 'none',
            }}
          />
        )}
      </div>

      {displayValue && (
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={() => {
            setQuery('');
            setOptions([]);
            onClear?.();
          }}
          disabled={disabled}
          tabIndex={-1}
          title="Limpar"
          style={{
            borderRadius: '0 4px 4px 0',
            borderLeft: 'none',
            padding: '0 7px',
            minHeight: 30,
          }}
        >
          ×
        </Button>
      )}

      {showDropdown && (
        <ul
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            zIndex: 9999,
            backgroundColor: '#fff',
            border: '1px solid #ced4da',
            borderTop: 'none',
            borderRadius: '0 0 6px 6px',
            maxHeight: 220,
            overflowY: 'auto',
            margin: 0,
            padding: 0,
            listStyle: 'none',
          }}
        >
          {options.map((m) => (
            <li
              key={m.codMed}
              onMouseDown={() => {
                onSelect(m);
                setShowDropdown(false);
              }}
              style={{
                padding: '5px 10px',
                fontSize: '0.82rem',
                cursor: 'pointer',
                display: 'flex',
                gap: 10,
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#eff6ff')}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '')}
            >
              <span style={{ minWidth: 38, fontWeight: 700, color: '#1d4ed8' }}>{m.codMed}</span>
              <span style={{ flex: 1 }}>{m.nome}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default function CampoMedico({
  label,
  codMed,
  nomeMed,
  onSelect,
  onClear,
  onCodigoChange,
  disabled,
  onProximoCampo,
  styles,
}) {
  // 2. Chamada ÚNICA do hook aqui no componente pai:
  const medicoSearch = useMedicoSearch();
  const { localizarPorCodigo } = medicoSearch;

  return (
    <div style={styles.row}>
      <span style={styles.label}>{label}:</span>
      <Form.Control
        data-enter-nav="true"
        size="sm"
        value={codMed}
        onChange={(e) => onCodigoChange?.(e.target.value)}
        onBlur={(e) => localizarPorCodigo(e.target.value, onSelect)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            localizarPorCodigo(e.target.value, onSelect);
            onProximoCampo(e);
          }
        }}
        onFocus={(e) => e.target.select()}
        disabled={disabled}
        style={{ ...styles.codeField, textTransform: 'uppercase' }}
      />
      {/* 3. Passa search={medicoSearch} para o filho */}
      <MedicoAsyncSelect
        key={`${codMed || ''}|${nomeMed || ''}`}
        nomeMed={nomeMed}
        onSelect={onSelect}
        onClear={onClear}
        disabled={disabled}
        styles={styles}
        search={medicoSearch}
      />
    </div>
  );
}
